import { requestHeaderSource, SOURCE_MAP, SUPPLIER, LOCAL_PRINT } from '@/utils/sourceMap'
import { getOrigin, getRootServer } from '@/utils/utils'
import { getPrintInnerAPIPrefix } from '@/utils/requestUtils'

/**
 * 获取请求BaseURL
 * @param {*} prefix 传入的URL前缀
 * @param {*} current 是否使用传入的URL的origin(默认false使用当前浏览器域名)
 * @returns baseURL
 */
export default prefix => {
    // 塔内接口域名
    const INNER_SER_DOMAIN = '.scm121.com'
    // 塔内接口前缀
    const INNER_SER_PREFIX = '/api/inner'

    if (REACT_APP_ENV.startsWith('dev') || !prefix) {
        return prefix
    }

    const baseUrl = new URL(prefix)

    if (prefix === PROJECT_CONFIG.baseTowerAftersaleApi) {
        return PROJECT_CONFIG.baseTowerAftersaleApi
    }

    if (prefix === PROJECT_CONFIG.baseTowerPrinterApi) {
        return PROJECT_CONFIG.baseTowerPrinterApi
    }

    // baseTowerDrpApi 域名不动态，直接写死
    if (prefix === PROJECT_CONFIG.baseTowerDrpApi) {
        return PROJECT_CONFIG.baseTowerDrpApi
    }
    if (PROJECT_CONFIG.localTerminalName === LOCAL_PRINT) {
        const PROJECT_SETTING = window.PROJECT_SETTING || {}
        const origin = prefix.includes(INNER_SER_PREFIX)
            ? getPrintInnerAPIPrefix() // PROJECT_SETTING.requestPrefixTower
            : PROJECT_SETTING.localRequestPrefix || PROJECT_SETTING.requestPrefix
        return origin + baseUrl.pathname
    }

    // 塔内接口比较特殊不能走网关，是必须唯一的，其它的塔内接口走当前的域名可能完网关访问服务
    if (prefix === PROJECT_CONFIG.baseTowerApi) {
        return `https://${PROJECT_CONFIG.towerHostPrefix}${INNER_SER_DOMAIN}${baseUrl.pathname}`
    }

    // baseUrl一般是绝对路径，这里取origin的原因是需要支持多域名
    //  idea: 可以把prefix全部换成相对路径，统一走网关
    const origin = getOrigin()

    // 塔内单开时候 内调用的塔外接口
    if (origin.includes(PROJECT_CONFIG.towerFrontHostPrefix)) {
        const rootServer = getRootServer()
        const source = requestHeaderSource()
        const hostPrefix =
            source === SOURCE_MAP[SUPPLIER] ? PROJECT_CONFIG.supplierHostPrefix : PROJECT_CONFIG.channelHostPrefix
        return `https://${hostPrefix}.${rootServer}${baseUrl.pathname}`
    }

    return origin + baseUrl.pathname
}
